import { IDateDelimiter, ListItemTypename } from 'listItem.types'
import { MMM_DD_YYYY } from 'utility/timeFormats'

export const getDateSeparatedList =
  <T extends { occurredAt?: string; createdAt: string }>(
    formatWithTimeZone: (date: Date | string | number, dateFormat: string) => string,
    includeTopDateSeparator: boolean = false,
    separateByMonth: boolean = false
  ) =>
  (listItems: T[]) => {
    if (!listItems.length) return []
    const dateFormat = separateByMonth ? 'MMM yyyy' : MMM_DD_YYYY
    let currentDate = includeTopDateSeparator
      ? ''
      : formatWithTimeZone(listItems[0].occurredAt || listItems[0].createdAt, dateFormat)

    const dateSeparatedItems = listItems.reduce(
      (acc: (T | IDateDelimiter)[], listItem: T, i: number) => {
        const nextCurrentDate = formatWithTimeZone(
          listItem.occurredAt || listItem.createdAt,
          dateFormat
        )

        if (nextCurrentDate && nextCurrentDate !== currentDate) {
          currentDate = nextCurrentDate
          acc.push({
            id: `date-section-${i}`,
            __typename: ListItemTypename.DateDelimiter,
            date: currentDate
          })
        }
        acc.push(listItem)

        return acc
      },
      []
    )

    return dateSeparatedItems
  }
